module.exports = __webpack_public_path__ + "img/generate link icon.16641b0a.svg";